import { render, staticRenderFns } from "./custom-box.vue?vue&type=template&id=3f4a6912&scoped=true"
import script from "./custom-box.vue?vue&type=script&lang=js"
export * from "./custom-box.vue?vue&type=script&lang=js"
import style0 from "./custom-box.vue?vue&type=style&index=0&id=3f4a6912&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a6912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4a6912')) {
      api.createRecord('3f4a6912', component.options)
    } else {
      api.reload('3f4a6912', component.options)
    }
    module.hot.accept("./custom-box.vue?vue&type=template&id=3f4a6912&scoped=true", function () {
      api.rerender('3f4a6912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EndUserViews/pickupManagement/custom-box.vue"
export default component.exports